import { render } from "./OutboundEmailList.vue?vue&type=template&id=6de8a98a&scoped=true&ts=true"
import script from "./OutboundEmailList.vue?vue&type=script&lang=ts"
export * from "./OutboundEmailList.vue?vue&type=script&lang=ts"

import "./OutboundEmailList.vue?vue&type=style&index=0&id=6de8a98a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de8a98a"]])

export default __exports__